/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Proof_EyebrowInputs */

const en_funnel_ob_proof_eyebrow = /** @type {(inputs: Funnel_Ob_Proof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're in good company`)
};

const es_funnel_ob_proof_eyebrow = /** @type {(inputs: Funnel_Ob_Proof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás en buena compañía`)
};

/**
* | output |
* | --- |
* | "You're in good company" |
*
* @param {Funnel_Ob_Proof_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_proof_eyebrow = /** @type {((inputs?: Funnel_Ob_Proof_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Proof_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_proof_eyebrow(inputs)
	return en_funnel_ob_proof_eyebrow(inputs)
});